import { forwardRef, createElement } from 'react';
import 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import 'reakit/Overlay';
import '../Overlay/OverlayContainer.js';
import '../Overlay/styled.js';
import { overlayHidePropTypes, overlayHideDefaultProps } from '../Overlay/OverlayHide.js';
import '../Overlay/OverlayShow.js';
import '../Overlay/OverlayToggle.js';
import '../chunk-7b491460.js';
import '../Overlay/index.js';
import { ModalHide as ModalHide$1 } from './styled.js';

var ModalHide = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return (// @ts-ignore
    createElement(ModalHide$1, _extends({}, props, {
      ref: ref
    }), children)
  );
});
ModalHide.propTypes = _objectSpread({}, overlayHidePropTypes);
ModalHide.defaultProps = _objectSpread({}, overlayHideDefaultProps); // @ts-ignore

var C = ModalHide;

export default C;
